/**
 * The calendar day an instant falls on in the gym's zone, as YYYY-MM-DD.
 * en-CA formats that way; toISOString() would name the UTC day instead, which
 * is the day before for a plan starting at midnight in any gym east of
 * Greenwich.
 */
export function gymLocalDate(instant: Date, timezone: string | null): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: timezone ?? undefined }).format(instant)
}
